var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.28 21.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.26,14.82c0,1.67,0,3.34,0,5,0,1-.44,1.47-1.47,1.47H12.13c-1,0-1.46-.4-1.49-1.35a.61.61,0,0,1,0-.14c0-4.21,0-8.41,0-12.62a3.38,3.38,0,0,0-3.37-3.4,3.19,3.19,0,0,0-.8.1A3.38,3.38,0,0,0,4,8.11,3.32,3.32,0,0,0,7.2,10.49a3.38,3.38,0,0,0,1.12-.19c.26-.09.52-.21.79-.3a.46.46,0,0,1,.19,0c.2,0,.3.14.34.38a1.61,1.61,0,0,1,0,.31V20.5c0,.51-.06.67-.42.67l-.31,0A8.87,8.87,0,0,1,5.53,20,12.23,12.23,0,0,1,4,18.88,10.6,10.6,0,0,1,6.19,1a10.29,10.29,0,0,1,4.38-1A10.62,10.62,0,0,1,20.83,7.75a15.21,15.21,0,0,1,.41,3.09C21.31,12.16,21.26,13.49,21.26,14.82Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.6ec934efc811e7cdba18626dace783b9.svg";
export { ForwardRef as ReactComponent };